/**
 * @function handleAllChecked
 * @param { array } values
 * @param { boolean } keyword
 * @returns { array }
 */
function handleAllChecked(values, keyword) {
	let newValues = Array.from(values);

	for (let i = 0; i < newValues.length; i++) {
		newValues[i].checked = keyword;
	}

	return newValues;
}

export default handleAllChecked;
